import { PagedQuery } from "@rsm-hcd/javascript-core";
import { ServiceFactory } from "@rsm-hcd/javascript-react";
import GroupMigrationRequestRecord from "models/view-models/group-migration-request-record";
import GroupWithPurchaserRecord from "models/view-models/group-with-purchaser-record";
import SearchQuery from "utilities/interfaces/search-query";

export interface GroupWithAdminsListQueryParams
    extends SearchQuery,
        PagedQuery {
    subscriptionId?: number;
}
const baseEndpoint = "admin/teams";
const migrateEndpoint = `${baseEndpoint}/migrate`;

const resourceType = GroupWithPurchaserRecord;
const migrateResourceType = GroupMigrationRequestRecord;

const TeamsAdminService = {
    list: ServiceFactory.list<
        GroupWithPurchaserRecord,
        GroupWithAdminsListQueryParams
    >(resourceType, baseEndpoint),
    /**
     * migrate a Group's owner and members to another group
     */
    migrate: ServiceFactory.create<GroupMigrationRequestRecord>(
        migrateResourceType,
        migrateEndpoint
    ),
};

export default TeamsAdminService;
